import React from "react";
import { useLocation } from "react-router-dom";
import { map, isEmpty } from "lodash";
import { connect, type ConnectedProps } from "react-redux";
import { push } from "store/actions/router";
import { Row, Col, Tab, Tabs, Card } from "react-bootstrap";

import { setTab } from "actions/navigationActions";
import ProfileInfo from "./ProfileInfo";
import CloseAccount from "./CloseAccount";
import LoginInfo from "./LoginInfo";
import { getIraAccountIdSelector } from "store/selectors/user";
import type { RootState } from "types/state";

import SuitabilityProfile from "./SuitabilityProfile";
const tabs = [
  {
    label: "Info",
    id: "info",
  },
  {
    label: "Investment Profile",
    id: "investment-profile",
  },
  {
    label: "Login Info",
    id: "login-info",
  },
  {
    label: "Close Account",
    id: "close-account",
  },
];

function calcActiveTab(routeName: string | undefined) {
  switch (routeName) {
    case "/dashboard/profile/info":
      return "info";
    case "/dashboard/profile/close-account":
      return "close-account";
    case "/dashboard/profile/login-info":
      return "login-info";
    case "/dashboard/profile/investment-profile":
      return "investment-profile";
    default:
      return "info";
  }
}

import "./IndividualProfile.scss";

const mapStateToProps = (state: RootState) => {
  return {
    accountId: getIraAccountIdSelector(state),
  };
};

const mapDispatchToProps = { push, setTab };

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

interface OwnProps {
  routeName?: string;
}

type Props = OwnProps & PropsFromRedux;

interface State {
  tab: string | null;
}

class IndividualProfile extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      tab: calcActiveTab(props.routeName),
    };
  }

  componentDidMount() {
    if (isEmpty(this.props.accountId)) {
      this.props.push("/dashboard?noAccount=true");
      return;
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.routeName !== this.props.routeName) {
      this.setState({ tab: calcActiveTab(this.props.routeName) });
    }
  }

  tabUpdate(value: { k: string | null }) {
    this.setState({ tab: value.k });
    this.props.push("/dashboard/profile/" + value.k);
  }

  _controlledTabs() {
    return (
      <Tabs
        // @ts-expect-error react-bootstrap activeKey is EventKey (string|number);
        // state.tab is string|null because Tabs.onSelect can yield null. Passing
        // null through preserves the original JS behavior (no value coercion).
        activeKey={this.state.tab}
        id="tab-company"
        onSelect={(k) => this.tabUpdate({ k })}
      >
        {map(tabs, (tab) => {
          return <Tab key={tab.id} eventKey={tab.id} title={tab.label} />;
        })}
      </Tabs>
    );
  }

  _getCardContent = () => {
    switch (this.state.tab) {
      case "info":
        return <ProfileInfo />;
      case "close-account":
        return <CloseAccount />;
      case "login-info":
        return <LoginInfo />;
      case "investment-profile":
        return <SuitabilityProfile />;
    }
  };

  render() {
    const content = this._getCardContent();
    return (
      <div className="mega-container" id="user-profile">
        <section className="page-title-wrap">
          <article className="text-cell">
            <h1 className="page-title">User Profile</h1>
            <p className="page-subtext">
              Manage your user information and linked bank accounts.
            </p>
            <div className="main-content">
              <Row>
                <Col>
                  <div className="card-tab">{this._controlledTabs()}</div>
                  <Card className="dashboard-widget">
                    <Card.Body>{content}</Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
          </article>
        </section>
      </div>
    );
  }
}

const IndividualProfile_WithLocation = (props: PropsFromRedux) => {
  const { pathname: routeName } = useLocation();
  return <IndividualProfile {...props} routeName={routeName} />;
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IndividualProfile_WithLocation);
